import * as React from 'react';
import PropTypes from "prop-types";
import PriceFormatted from "../../Application/PriceFormatted";
import Icon from "../../../componentsReusable/Icon";
import {UncontrolledTooltip} from "reactstrap";
import uuid from "react-native-uuid";
import {PRICE_TYPE_GROSS} from "../../../utils/price";

function WarehouseProductSellPrice({product, showPrice}) {
  const [id, setId] = React.useState('t' + uuid.v4());

  let priceKey = 'priceNet'
  if(showPrice === PRICE_TYPE_GROSS){
    priceKey = 'priceGross'
  }
  const sellPriceGroup = product.priceGroups.find(priceGroup => priceGroup.workshopProductPriceGroup.default);

  let tooltip = product.priceGroups.map((priceGroup, key) => {
    return <li className="w-100 d-flex justify-content-between" key={key}><span className="mr-2">{priceGroup.workshopProductPriceGroup.name}:</span> <PriceFormatted value={priceGroup[priceKey]} /></li>
  })

  return <span>
    {product.useIndividualPrices && <Icon className="fas fa-info-circle text-warning mr-2" tooltip={"Ceny ustawione indywidualnie"} />}
    <span id={id}><PriceFormatted value={sellPriceGroup[priceKey]} /></span>
    {product.priceGroups.length > 1 && <UncontrolledTooltip target={id} placement="left" fade={false}>
      <ul className="list-group">{tooltip}</ul>
    </UncontrolledTooltip>}
  </span>}

WarehouseProductSellPrice.propTypes = {
  product: PropTypes.shape({
    useIndividualPrices: PropTypes.bool.isRequired,
    priceGroups: PropTypes.arrayOf(PropTypes.shape({
      workshopProductPriceGroup: PropTypes.shape({
        default: PropTypes.bool.isRequired,
        name: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,).isRequired,
  }).isRequired,
};

export default WarehouseProductSellPrice;
